import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProviderPageLayout from '../../components/ProviderPageLayout';

const ProviderCookies = () => {
  const navigate = useNavigate();

  return (
    <ProviderPageLayout variant="auth" bare>
      <div className="provider-legal">
        <div className="provider-legal-header">
          <p className="provider-eyebrow">Legal</p>
          <h1 className="provider-title">Cookie Policy</h1>
          <p className="provider-legal-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="provider-legal-body">
          <p>
            This Cookie Policy explains how RetechSys LLC (&quot;ReTechSys&quot;) uses cookies and
            similar technologies in the Provider Portal.
          </p>

          <h2>1. What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device that help websites function and
            remember your preferences. We also use browser storage (localStorage) for similar
            purposes.
          </p>

          <h2>2. How We Use Cookies</h2>
          <p>We use a minimal set of cookies and storage, grouped as follows:</p>

          <table className="provider-legal-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Purpose</th>
                <th>Required</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Essential</td>
                <td>Keep you signed in, maintain your session, and secure the Service.</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td>Preferences</td>
                <td>Remember your cookie choice and in-progress signup details.</td>
                <td>No</td>
              </tr>
              <tr>
                <td>Payments</td>
                <td>Set by Stripe to process payments securely and prevent fraud.</td>
                <td>Yes</td>
              </tr>
            </tbody>
          </table>

          <h2>3. Managing Cookies</h2>
          <p>
            When you first visit, we ask for your consent to non-essential cookies. You can also
            control cookies through your browser settings. Note that disabling essential cookies may
            prevent you from signing in or using core features.
          </p>

          <h2>4. Third-Party Cookies</h2>
          <p>
            Our payment processor, Stripe, sets its own cookies to enable secure checkout and fraud
            prevention. These are governed by Stripe&apos;s cookie and privacy policies.
          </p>

          <h2>5. Changes to This Policy</h2>
          <p>
            We may update this Cookie Policy periodically. The &quot;Last updated&quot; date above
            reflects the latest revision.
          </p>

          <h2>6. Contact</h2>
          <p>
            Questions about cookies? Email{' '}
            <a href="mailto:support@retechsys.ai">support@retechsys.ai</a>.
          </p>
        </div>

        <div style={{ marginTop: 40 }}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="provider-btn provider-btn--secondary provider-btn--inline"
          >
            ← Back
          </button>
        </div>
      </div>
    </ProviderPageLayout>
  );
};

export default ProviderCookies;
